import React, { useEffect, useState } from 'react';
import styles from './BusinessPerformanceOverview.module.scss';
import ViewPlaybookLight from '../../../../assets/images/LightTheme/view_playbook.svg';
import ViewPlaybookDark from '../../../../assets/images/DarkTheme/view_playbook.svg';
import { useAppSelector } from '../../../../redux/hooks';
import AIInsight from '../../../common/InsightAI/InsightAI';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { useTranslation } from 'react-i18next';
import {
  downloadDocument,
  useProfileParams,
  isAISummariesAccessible,
} from '../../../../utils/common';
import { useGetAGCAISummaryQuery } from '../../../../redux/services/agcAIAPI';

const BusinessPerformanceOverview: React.FC = () => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const { t } = useTranslation();
  const playbookImage = currentTheme === 'light' ? ViewPlaybookLight : ViewPlaybookDark;
  const closingMonth: any =
    useSelector(
      (state: RootState) => state?.businessPerformanceClosingMonth?.businessPerformanceClosingMonth
    ) || '';
  const [agcSummaryData, setAGCSummaryData] = useState(null);

  const { affiliateCode, aboNumber } = useProfileParams();

  const { data: agcAISummary, isFetching } = useGetAGCAISummaryQuery(
    {
      affiliateCode,
      aboNumber,
    },
    {
      skip: Number(affiliateCode) === 0 || aboNumber === 0,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    setAGCSummaryData(agcAISummary?.body?.summary ?? '');
  }, [agcAISummary]);

  return (
    <div className={`business_performance ${styles.business_performance}`}>
      <div>
        <div className={`header ${styles.header}`}>
          <span className={`title ${styles.title}`}>{t('businessPerformance')}</span>
          <span
            onClick={() => downloadDocument('playbook')}
            className={`playbook_link ${styles.playbook_link}`}
          >
            <img
              src={playbookImage}
              alt="Playbook icon"
              className={`playbook_icon ${styles.playbook_icon}`}
            />
            <span className={`playbook_text ${styles.playbook_text}`}>{t('viewPlaybook')}</span>
          </span>
        </div>

        <div className={`last_closed_month_wrapper ${styles.last_closed_month_wrapper}`}>
          <span className={`last_closed_month ${styles.last_closed_month}`}>
            {t('Last_closed_month')} {closingMonth}
          </span>
        </div>

        {/* AIInsight component usage with dropdown */}
        {isAISummariesAccessible() &&
          (isFetching ? (
            <div className={`${styles.ai_insight_wrapper} animate`}></div>
          ) : (
            <AIInsight
              updateDate="08/19/2024"
              content={agcSummaryData}
              className={styles.insight_ai}
              showDropdown={true}
              isDropdownEnabled={true}
              flowerIconSize={24}
              infoIconSize={12}
              title={'ai_summary'}
              titleSize={16}
            />
          ))}
      </div>
    </div>
  );
};

export default BusinessPerformanceOverview;
